<template>
  <div id="duyfken360">
  <CameraView></CameraView>
  <div class="container">
    <div class="header ship-drop-shadow">
      <h2 class="room-text"></h2>
      <ShipMap></ShipMap>
    </div>
  </div>
</div>
</template>

<script>
import ShipMap from "@/components/ShipMap.vue";
import CameraView from "@/components/CameraView.vue";
export default {
  name: "DuyfkenView",
  components: {
    ShipMap,
    CameraView,
  },
  props: {},
  data() {
    return {}
  },
  computed: {
    areaName() {
      return this.shipAreas[this.shipArea].name
    },
    shipArea() {
      return this.$store.getters.getShipArea
    },
    shipAreas() {
      return this.$store.getters.getShipAreas
    }
  },
  methods: {},
  mounted() {}
};
</script>

<style scoped>
.container {
  pointer-events: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
.header {
  pointer-events:none;
  display: flex;
  justify-content: space-between;
  margin: 2em;
}
.ship-drop-shadow {
  filter: drop-shadow(0 0 0.15em var(--indigo))
          drop-shadow(0 0 0.15em var(--indigo))
          drop-shadow(0 0 0.15em var(--indigo));
}
</style>